import { AbstractControl, ValidationErrors } from "@angular/forms";

export function emailValidator(control: AbstractControl): ValidationErrors | null {
    // Expressão regular para validar o formato do email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Obtém o valor do controle
    const value = control.value;

    // Verifica se o valor corresponde ao formato do email
    if (value && !emailRegex.test(value)) {
        // Retorna um objeto de erros com uma chave personalizada
        return {
            email: true,
            mensagem: (campo: string) => `O campo <b>${campo}</b> não é um email válido`
        };
    }

    // Retorna null se o valor for válido
    return null;
}
